// extracted by mini-css-extract-plugin
module.exports = {"label":"_3qBszJA2hZrRYqkbzgpAJM","active":"_3SqvgGO_tQwuIxHulDfdh4"};